import { NodesResponse } from '../types'

export const getNodes = (): NodesResponse => {
    return {
        nodes: [
            {
                nodeName: 'Root',
                nodeId: 0,
                nodes: [
                    {
                        nodeName: 'Node 1',
                        nodeId: 1,
                        nodes: [
                            {
                                nodeName: 'Node 7',
                                nodeId: 7,
                                nodes: [],
                            },
                            {
                                nodeName: 'Node 8',
                                nodeId: 8,
                                nodes: [],
                            },
                        ],
                    },
                    {
                        nodeName: 'Node 2',
                        nodeId: 2,
                        nodes: [
                            {
                                nodeName: 'Node 9',
                                nodeId: 9,
                                nodes: [],
                            },
                            {
                                nodeName: 'Node 10',
                                nodeId: 10,
                                nodes: [
                                    {
                                        nodeName: 'Node 11',
                                        nodeId: 11,
                                        nodes: [],
                                    },
                                    {
                                        nodeName: 'Node 12',
                                        nodeId: 12,
                                        nodes: [],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        nodeName: 'Node 3',
                        nodeId: 3,
                        nodes: [],
                    },
                    {
                        nodeName: 'Node 4',
                        nodeId: 4,
                        nodes: [],
                    },
                    {
                        nodeName: 'Node 5',
                        nodeId: 5,
                        nodes: [],
                    },
                    {
                        nodeName: 'Node 6',
                        nodeId: 6,
                        nodes: [],
                    },
                ],
            },
        ].sort((a, b) => a.nodeName.localeCompare(b.nodeName)),
    }
}
